<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Audio Tracks</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Manage Audio Tracks</strong>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            style="margin-left: 15px;"
            :to="{ name: 'AlbumAddTracks', params: { id: $route.params.id }}"
          >
            Add new Audio Tracks
          </router-link>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'AlbumOrderTracks', params: { id: $route.params.id }}"
          >
            Order tracks
          </router-link>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'AlbumEdit', params: { id: $route.params.id }}"
          >
            Back to General
          </router-link>
        </div>

        <div class="card-block">
          <input
            v-model="searchQuery"
            type="text"
            class="form-control"
            placeholder="Search by Audio Tracks title"
          >
        </div>
        <div class="card-block spinner-parent">
          <spinner ref="spinner" size="md" text="Loading ..." />

          <div class="table-responsive">
            <table class="entities table table-bordered table-striped table-sm">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="total">
                <tr v-for="item in tracks" :key="item.id" :data-id="item.id">
                  <td class="table-list__cell--narrow">{{ item.id }}</td>
                  <td>{{ item.title }}</td>
                  <td class="table-list__cell--narrow">
                    <button class="btn btn-danger btn-sm" @click="deleteAudioTrack(item)">
                      Delete
                      <span class="btn-loader" style="display: none;" />
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="text-center">
                    There are no audio tracks yet. Go to 'Add new Audio Tracks' to add new ones.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <nav>
            <pager
              :total="total"
              :offset="offset"
              :size="perPage"
              @page-changed="changePage"
            />
          </nav>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'AlbumManageTracks',

  components: {
    pager: Pager,
  },

  data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      tracks: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getTracks();
    }, 400),
    offset() {
      this.getTracks();
    },
  },

  mounted() {
    this.getTracks();
  },

  methods: {
    getTracks() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}/tracks`, {
        params: {
          search_string: searchString,
          page,
        },
      })
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.spinner) { this.$refs.spinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            let tracksArr = _.cloneDeep(response.data);
            delete tracksArr.meta;
            tracksArr = Object.keys(tracksArr).map(item => tracksArr[item]);
            if (!searchString) {
              this.tracks = this.orderByWeight(tracksArr);
            } else {
              this.tracks = tracksArr;
            }
          }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          console.error(error);
        });
    },
    orderByWeight(arr) {
      return arr.sort((a, b) => {
        const weightA = a.weight ? +a.weight : 0;
        const weightB = b.weight ? +b.weight : 0;
        if (weightA > weightB) {
          return 1;
        }
        return -1;
      });
    },
    deleteAudioTrack(track) {
      if (window.confirm(`Do you really want to detach audio track ${track.title} with id = ${track.id}?`)) {
        const postFormData = new FormData();
        const $btnDeleteLoader = $(`table.entities tr[data-id="${track.id}"] .btn-danger .btn-loader`);
        $btnDeleteLoader.show();
        postFormData.append('ids[]', track.id);
        this.$apiHttp.post(
          `${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}/detach/tracks`,
          postFormData,
        ).then(() => {
          $btnDeleteLoader.hide();
          this.getTracks();
        }).catch((error) => {
          console.error('Error in detach audio track request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage(offset) {
      this.offset = offset;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ManageTracks.vue?90317868